import { render, staticRenderFns } from "./SalesFlyerApp.vue?vue&type=template&id=2771f9e2&scoped=true"
import script from "./SalesFlyerApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./SalesFlyerApp.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SalesFlyerApp.vue?vue&type=style&index=0&id=2771f9e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2771f9e2",
  null
  
)

export default component.exports